'use client';
import React, { useState, useMemo } from 'react';
import { Autoplay, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';

import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import { Zoom, Fullscreen } from 'yet-another-react-lightbox/plugins';

// ---- your imports (unchanged) ----

import resbak2 from '../../../assets/images/resbak2/group.jpg';
import resbak2_1 from '../../../assets/images/resbak2/B CHAMPION.png';
import resbak2_2 from '../../../assets/images/resbak2/B RUNNER UP.png';
import resbak2_3 from '../../../assets/images/resbak2/C LOWER CHAMPION.png';
import resbak2_4 from '../../../assets/images/resbak2/C LOWER RUNNER UP.png';
import resbak2_5 from '../../../assets/images/resbak2/C UPPER CHAMPION.png';
import resbak2_6 from '../../../assets/images/resbak2/C UPPER RUNNER UP.png';
import resbak2_7 from '../../../assets/images/resbak2/D CHAMPION.png';
import resbak2_8 from '../../../assets/images/resbak2/D RUNNER UP.png';
import resbak2_9 from '../../../assets/images/resbak2/E LOWER CHAMPION.png';
import resbak2_10 from '../../../assets/images/resbak2/E LOWER RUNNER UP.png';
import resbak2_11 from '../../../assets/images/resbak2/E UPPER CHAMPION.png';
import resbak2_12 from '../../../assets/images/resbak2/E UPPER RUNNER UP.png';
import resbak2_13 from '../../../assets/images/resbak2/F CHAMPION.png';
import resbak2_14 from '../../../assets/images/resbak2/F RUNNER UP.png';
import resbak2_15 from '../../../assets/images/resbak2/G CHAMPION.png';
import resbak2_16 from '../../../assets/images/resbak2/G RUNNER UP.png';


import yugtoPic1 from '../../../assets/images/rrc/gallery/yugto/1.jpg';
import yugtoPic2 from '../../../assets/images/rrc/gallery/yugto/2.jpg';
import yugtoPic3 from '../../../assets/images/rrc/gallery/yugto/3.jpg';
import yugtoPic4 from '../../../assets/images/rrc/gallery/yugto/4.jpg';
import yugtoPic5 from '../../../assets/images/rrc/gallery/yugto/5.jpg';

import galleryImg1 from '../../../assets/images/rrc/gallery/1.jpg';
import galleryImg2 from '../../../assets/images/rrc/gallery/2.jpg';
import galleryImg3 from '../../../assets/images/rrc/gallery/3.jpg';
import galleryImg4 from '../../../assets/images/rrc/gallery/4.jpg';
import galleryImg5 from '../../../assets/images/rrc/gallery/5.jpg';
import galleryImg6 from '../../../assets/images/rrc/gallery/6.jpg';
import galleryImg_7 from '../../../assets/images/rrc/gallery/7.jpg';

// bday tourna
import galleryImg7 from '../../../assets/images/rrc/gallery/bday-winners/C-B.png';
import galleryImg8 from '../../../assets/images/rrc/gallery/bday-winners/C-C.png';
import galleryImg9 from '../../../assets/images/rrc/gallery/bday-winners/C-D.png';
import galleryImg10 from '../../../assets/images/rrc/gallery/bday-winners/C-E.png';
import galleryImg11 from '../../../assets/images/rrc/gallery/bday-winners/C-F.png';
import galleryImg12 from '../../../assets/images/rrc/gallery/bday-winners/C-G.png';
import galleryImg13 from '../../../assets/images/rrc/gallery/bday-winners/R-B.png';
import galleryImg14 from '../../../assets/images/rrc/gallery/bday-winners/R-C.png';
import galleryImg15 from '../../../assets/images/rrc/gallery/bday-winners/R-D.png';
import galleryImg16 from '../../../assets/images/rrc/gallery/bday-winners/E-R.png';
import galleryImg17 from '../../../assets/images/rrc/gallery/bday-winners/R-F.png';
import galleryImg18 from '../../../assets/images/rrc/gallery/bday-winners/R-G.png';

// ---- data (unchanged) ----
const galleryItems = [
  { image: resbak2, title: "Resbak 2.0 - November 30, 2025", subtitle: "Racket Riot Club", link: "#Gallery" },
  { image: resbak2_1, title: "Resbak 2.0 - November 30, 2025", subtitle: "B CHAMPION", link: "#Gallery" },
  { image: resbak2_2, title: "Resbak 2.0 - November 30, 2025", subtitle: "B RUNNER UP", link: "#Gallery" },
  { image: resbak2_3, title: "Resbak 2.0 - November 30, 2025", subtitle: "C LOWER CHAMPION", link: "#Gallery" },
  { image: resbak2_4, title: "Resbak 2.0 - November 30, 2025", subtitle: "C LOWER RUNNER UP", link: "#Gallery" },
  { image: resbak2_5, title: "Resbak 2.0 - November 30, 2025", subtitle: "C UPPER CHAMPION", link: "#Gallery" },
  { image: resbak2_6, title: "Resbak 2.0 - November 30, 2025", subtitle: "C UPPER RUNNER UP", link: "#Gallery" },
  { image: resbak2_7, title: "Resbak 2.0 - November 30, 2025", subtitle: "D CHAMPION", link: "#Gallery" },
  { image: resbak2_8, title: "Resbak 2.0 - November 30, 2025", subtitle: "D RUNNER UP", link: "#Gallery" },
  { image: resbak2_9, title: "Resbak 2.0 - November 30, 2025", subtitle: "E LOWER CHAMPION", link: "#Gallery" },
  { image: resbak2_10, title: "Resbak 2.0 - November 30, 2025", subtitle: "E LOWER RUNNER UP", link: "#Gallery" },
  { image: resbak2_11, title: "Resbak 2.0 - November 30, 2025", subtitle: "E UPPER CHAMPION", link: "#Gallery" },
  { image: resbak2_12, title: "Resbak 2.0 - November 30, 2025", subtitle: "E UPPER RUNNER UP", link: "#Gallery" },
  { image: resbak2_13, title: "Resbak 2.0 - November 30, 2025", subtitle: "F CHAMPION", link: "#Gallery" },
  { image: resbak2_14, title: "Resbak 2.0 - November 30, 2025", subtitle: "F RUNNER UP", link: "#Gallery" },
  { image: resbak2_15, title: "Resbak 2.0 - November 30, 2025", subtitle: "G CHAMPION", link: "#Gallery" },
  { image: resbak2_16, title: "Resbak 2.0 - November 30, 2025", subtitle: "G RUNNER UP", link: "#Gallery" },

  { image: yugtoPic1, title: "YUGTO: 1st Anniversary Tournament for a Cause 2025", subtitle: "Racket Riot Club", link: "#Gallery" },
  { image: yugtoPic2, title: "YUGTO: 1st Anniversary Tournament for a Cause 2025", subtitle: "CHAMPIONS", link: "#Gallery" },
  { image: yugtoPic3, title: "YUGTO: 1st Anniversary Tournament for a Cause 2025", subtitle: "RUNNERS UP", link: "#Gallery" },
  { image: yugtoPic4, title: "YUGTO: 1st Anniversary Tournament for a Cause 2025", subtitle: "BEST PAIRS", link: "#Gallery" },
  { image: yugtoPic5, title: "YUGTO: 1st Anniversary Tournament for a Cause 2025", subtitle: "MVP", link: "#Gallery" },

  { image: galleryImg1, title: " RRC’s 2nd Fun Tournament, RESBAK 2024", subtitle: "CHAMPIONS", link: "#Gallery" },
  { image: galleryImg4, title: " RRC’s 2nd Fun Tournament, RESBAK 2024", subtitle: "RUNNERS UP", link: "" },
  { image: galleryImg3, title: " RRC’s 2nd Fun Tournament, RESBAK 2024", subtitle: "BEST PAIRS", link: "" },
  { image: galleryImg2, title: " RRC’s 2nd Fun Tournament, RESBAK 2024", subtitle: "MVP", link: "" },
  { image: galleryImg5, title: " RRC’s 2nd Fun Tournament, RESBAK 2024", subtitle: "Racket Riot Club", link: "" },
  { image: galleryImg6, title: " RRC’s 2nd Fun Tournament, RESBAK 2024", subtitle: "Racket Riot Club", link: "" },
  { image: galleryImg_7, title: " RRC’s 2nd Fun Tournament, RESBAK 2024", subtitle: "Racket Riot Club", link: "" },

  // Birthday
  { image: galleryImg7, title: "RRC - Birthday Tournament", subtitle: "Racket Riot Club", link: "" },
  { image: galleryImg8, title: "RRC - Birthday Tournament", subtitle: "Racket Riot Club", link: "" },
  { image: galleryImg9, title: "RRC - Birthday Tournament", subtitle: "Racket Riot Club", link: "" },
  { image: galleryImg10, title: "RRC - Birthday Tournament", subtitle: "Racket Riot Club", link: "" },
  { image: galleryImg11, title: "RRC - Birthday Tournament", subtitle: "Racket Riot Club", link: "" },
  { image: galleryImg12, title: "RRC - Birthday Tournament", subtitle: "Racket Riot Club", link: "" },
  { image: galleryImg13, title: "RRC - Birthday Tournament", subtitle: "Racket Riot Club", link: "" },
  { image: galleryImg14, title: "RRC - Birthday Tournament", subtitle: "Racket Riot Club", link: "" },
  { image: galleryImg15, title: "RRC - Birthday Tournament", subtitle: "Racket Riot Club", link: "" },
  { image: galleryImg16, title: "RRC - Birthday Tournament", subtitle: "Racket Riot Club", link: "" },
  { image: galleryImg17, title: "RRC - Birthday Tournament", subtitle: "Racket Riot Club", link: "" },
  { image: galleryImg18, title: "RRC - Birthday Tournament", subtitle: "Racket Riot Club", link: "" },
];


export default function GalleryTwo() {
  const [open, setOpen] = useState(false);
  const [idx, setIdx] = useState(0);

  const slides = useMemo(
    () =>
      galleryItems.map((it) => ({
        src: it.image?.src || it.image,
        description: `${it.title} — ${it.subtitle}`,
      })),
    []
  );

  const handleOpen = (i) => {
    // sanity signal
    setIdx(i);
    setOpen(true);
  };

  return (
    <section id="th-gallery" className="gallery-two">
      <div className="gallery-two__top">
        <div className="container">
          <div className="gallery-two__top-inner">
            <div className="section-title text-left">
              <div className="section-title__tagline-box">
                <span className="section-title__tagline">Latest Gallery</span>
              </div>
              <h2 style={{ color: '#fff', margin: 0 }}>Riot Moments</h2>
            </div>
            <div className="rrc-nav">
  <div className="rrc-nav-btn prev"><i className="icon-angle-left" /></div>
  <div className="rrc-nav-btn next"><i className="icon-angle-right" /></div>
</div>
          </div>
        </div>
      </div>

      <div className="gallery-two__bottom">
        <div className="container">
          <div className="gallery-two__carousel-box">
            <Swiper
              modules={[Autoplay, Navigation]}
              slidesPerView={1}
              spaceBetween={12}
              speed={600}
              loop
              autoplay={{ delay: 5000 }}
              navigation={{
                prevEl: '.rrc-nav .prev',
                nextEl: '.rrc-nav .next'
              }}
              breakpoints={{
                0: { spaceBetween: 12, slidesPerView: 1 },
                575: { spaceBetween: 16, slidesPerView: 1 },
                768: { spaceBetween: 20, slidesPerView: 1 },
                992: { spaceBetween: 24, slidesPerView: 2 },
                1200: { spaceBetween: 24, slidesPerView: 3 },
                1320: { spaceBetween: 24, slidesPerView: 4 },
              }}
              // SAFE MODE: kill dragging so taps are pure clicks
              allowTouchMove={true}
              preventClicks={false}
              preventClicksPropagation={false}
              touchStartPreventDefault={false}
              threshold={8}
            >
              {galleryItems.map((item, index) => {
                const src = item.image?.src || item.image;
                return (
                  <SwiperSlide key={index}>
                    <div className="rrc-gallery-card" onClick={() => handleOpen(index)}>

                      <img src={src} alt={item.subtitle} loading="lazy" />

                      <div className="rrc-gallery-overlay">
                        <span className="rrc-gallery-tag">{item.subtitle}</span>
                        <h4>{item.title}</h4>
                      </div>

                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>

            {/* Lightbox */}
            <Lightbox
              open={open}
              close={() => setOpen(false)}
              index={idx}
              slides={slides}
              plugins={[Zoom, Fullscreen]}
              zoom={{ maxZoomPixelRatio: 3 }}
              controller={{ closeOnBackdropClick: true }}
            />
          </div>
        </div>
      </div>

      {/* 3) Nuclear fallback CSS (TEMPORARY). Uncomment to test if something else is eating clicks
      <style jsx global>{`
        #th-gallery.gallery-two * { pointer-events: none !important; }
        #th-gallery.gallery-two .rrc-click-catcher,
        #th-gallery.gallery-two .rrc-click-catcher * { pointer-events: auto !important; }
      `}</style>
      */}
    </section>
  );
}